import AbsComponent from "../../common/AbsComponent";
/**
 * Notice class
 * @category main
 */

class Notice extends AbsComponent {
    constructor(_store = {}, _el = '') {
        super(_store, _el);

        this.charServerType = this.store.data.config.charServerType;
        this.store.getData('mainNotices', {}, this.render.bind(this));
    }

    render(_jsonData = {}) {
        // console.log('render Notices ----->', _jsonData);
        $(this.el).append(this.template( _jsonData ));

    }

    template(_d={}){
        let templ = ''; //템플릿
        let templList = ''; //서버별 아이템 템플릿
        let itemOrder = []; //서버별 아이템 노출 순서
        let moreLink = '' //서버별 더보기 링크

        _d = JSON.parse(_d.jsonData);

        // 아이템 노출 순서


        if (this.charServerType == "lineage2") {
            itemOrder = _d.orderDefault.split(',').slice(0, 4);
            moreLink = _d.headerUrlDefault;
        } else if (this.charServerType == "lineage2Awakening") {
            itemOrder = _d.orderAwken.split(',').slice(0, 4);
            moreLink = _d.headerUrlAwken;
        } else {
            itemOrder = _d.orderOther.split(',').slice(0, 4);
            moreLink = _d.headerUrlOther;
        }



        // 리스트
        itemOrder.forEach(function(n) {
            templList += `
                <li class="notice-update-item">
                  <a href="${_d.items[n-1].url}" class="notice-update-link">${_d.items[n-1].title}</a>
                    ${_d.items[n-1].flag? `<em class="icon-new"><span class="blind">new</span></em>` : ``}
                </li>
            `
        })

        // 전체템플릿
        templ = `
            <section class="notice-update">
              <h2 class="notice-update-title">${_d.header}</h2>
              <ul class="notice-update-list">
                ${templList}
              </ul>
              <a href="${moreLink}" class="update-more-link"><span class="blind">더보기</span></a>
            </section>
        `;
        //console.log(templ);
        return templ;
    }
}

export default Notice;